<span
  [ngClass]="{
    'status-label': true,
    'status-label--positive': status == 1,
    'status-label--negative': status == 2
  }"
  ><span class="status-label__text"><ng-content></ng-content></span
></span>
